import {debug} from 'loglevel'
// import { get_login_by_ip, refresh_token } from '@/api'
import store from "@/store";
import jwt_decode from "jwt-decode"
const myStorage = window.localStorage

function getIdentity() {
  const { access_token } = getTokens()
  try {
    const decoded = jwt_decode(access_token)
    // debug('decoded', decoded)
    // debug('decoded.identity', decoded.identity)
    const {uname, auth_type, allow, isadmin, allow_uniname} = decoded.identity
    // auth_type: ip, (user?)
    // const isadmin = Boolean(allow && allow.includes("admin"))
    return {uname, auth_type, isadmin, allow, allow_uniname}
  }
  catch(e) {
    return {uname: "未登入/GUEST", auth_type: 'ip'}
  }
}

function setTokens(tokens)
{
  debug('setTokens', tokens)
  function setOrRemove(k, v) {
    if(v) {
      myStorage.setItem(k, v)
    }
    else {
      debug('removed', k)
      myStorage.removeItem(k)
    }
  }

  // debug('on setTokens', tokens)
  const {refresh_token, access_token} = tokens
  setOrRemove('access_token', access_token)
  setOrRemove('refresh_token', refresh_token)
  const {uname, auth_type, isadmin, allow, allow_uniname} = getIdentity()
  store.commit('set_login', {uname, auth_type, isadmin, allow, allow_uniname})
}

function getTokens()
{
  const access_token = myStorage.getItem('access_token')
  const refresh_token = myStorage.getItem('refresh_token')
  return {access_token, refresh_token}
}

debug('installing storage listener')
// myStorage.clear()
function storageListener() {
  // const access_token = myStorage.getItem('access_token')
  // const refresh_token = myStorage.getItem('refresh_token')
  const {uname, auth_type, isadmin, allow, allow_uniname} = getIdentity()
  store.commit('set_login', {uname, auth_type, isadmin, allow, allow_uniname})
  debug('on storage changed', uname, auth_type, isadmin, allow, allow_uniname)
}

window.addEventListener('storage', storageListener)

export {
  setTokens,
  getTokens,
  getIdentity,
}
